// Credential utility functions
export const handleCopyToClipboard = async (credentialData: any, fieldsToInclude: string[]) => {
  try {
    // Filter the credential data to only include specified fields
    const filteredData = fieldsToInclude.reduce((acc: any, field: string) => {
      if (credentialData[field] !== undefined) {
        acc[field] = credentialData[field];
      }
      return acc;
    }, {});

    await navigator.clipboard.writeText(JSON.stringify(filteredData, null, 2));
    return true;
  } catch (err) {
    console.error('Failed to copy: ', err);
    return false;
  }
};

export const handleDownload = (
  credentialData: any,
  fieldsToInclude: string[],
  filename: string = 'credentials.json'
) => {
  try {
    // Filter the credential data to only include specified fields
    const filteredData = fieldsToInclude.reduce((acc: any, field: string) => {
      if (credentialData[field] !== undefined) {
        acc[field] = credentialData[field];
      }
      return acc;
    }, {});

    const dataStr = JSON.stringify(filteredData, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return true;
  } catch (err) {
    console.error('Failed to download: ', err);
    return false;
  }
};

export const formatSensitiveValue = (value: string, isVisible: boolean) => {
  if (isVisible || !value) {
    return value;
  }
  if (value.length > 8) {
    return `${value.substring(0, 4)}${'*'.repeat(value.length - 8)}${value.substring(value.length - 4)}`;
  }
  return value;
};

export const formatDateValue = (
  dateString: string,
  dateFormat?: {
    year: 'numeric' | '2-digit';
    month: 'long' | 'short' | 'numeric' | '2-digit';
    day: 'numeric' | '2-digit';
    hour?: '2-digit';
    minute?: '2-digit';
  }
) => {
  try {
    const date = new Date(dateString);
    const formatOptions: Intl.DateTimeFormatOptions = {
      year: dateFormat?.year || 'numeric',
      month: dateFormat?.month || 'long',
      day: dateFormat?.day || 'numeric'
    };

    if (dateFormat?.hour) formatOptions.hour = dateFormat.hour;
    if (dateFormat?.minute) formatOptions.minute = dateFormat.minute;

    return date.toLocaleDateString('en-US', formatOptions);
  } catch {
    return dateString;
  }
};
